import {getAccountName} from 'src/openapi/admin/apis/GetAccountNameApi';
import {Account} from 'src/openapi/admin/models/Account';
import {useAppDispatch} from 'src/store/hooks';

import {COLUMNS} from '../../../constants';

type Props = {
    data: Record<string, string>[],
    accounts: Array<Account>,
    selectedColumns: string[],
    apiDispatch: ReturnType<typeof useAppDispatch>,
};

export const fetchParentAccountNames = async (props: Props): Promise<Record<string, string>[] | null> => {
    const {data, accounts, selectedColumns, apiDispatch} = props;
    if (!selectedColumns.includes(COLUMNS.PARENT_ACCOUNT_NAME)) {
        return data;
    }

    const parentAccountIds = accounts.map(a => a.parentAccountId).filter(Boolean);
    const uniqueIds = [...new Set(parentAccountIds)];

    const response = await apiDispatch(getAccountName({requestBody: uniqueIds}));
    if (!response.payload.success) {
        return null;
    }

    const nameMap = response.payload.data;
    return data.map(row => ({
        ...row,
        [COLUMNS.PARENT_ACCOUNT_NAME]: nameMap[row[COLUMNS.PARENT_ACCOUNT_NAME]] || '',
    }));
};
